import React, { useState, useEffect } from 'react';

import { Skeleton } from 'antd';
import Axios from 'axios';

import styled from 'styled-components';

import { useContact } from '@hooks/API/Contact/UseContact';
import { useContactConnections } from '@hooks/API/Contact/UseContactConnections';

import NwIcon from '@components/Gui/NwIcon';

import EmailSearchItem from './EmailSearchItem';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    padding: 2rem 1rem;

    .related-emails-box {
        margin-bottom: 1rem;
        border-bottom: ${(props) => props.theme.LighterBorder};
        padding-bottom: 1rem;

        h2 {
            font-size: ${(props) => props.theme.FontSizeBase};
            font-weight: 600;
            text-transform: uppercase;
            margin: 0 0 0.5rem 0;
        }

        .related-emails-box-content {
            padding-left: 1rem;
        }
    }
`;

const EmailContactRelated = ({ contactID, onAddEmail, selectedItems }) => {
    const [contactEmails, setContactEmails] = useState([]);
    const [motherAgencyEmail, setMotherAgencyEmail] = useState([]);
    const [motherAgencyName, setMotherAgencyName] = useState('');

    const { data: currentContact, isLoading: isLoadingContact } = useContact(contactID);
    const { data: Connections, isLoading: isLoadingConnections } = useContactConnections(contactID);

    const getEmailsFromConnections = (connectionsForEmails) => {
        const emails = [];
        for (const connection of connectionsForEmails) {
            if (connection.Emails.length > 0) {
                for (const email of connection.Emails) {
                    const emailItem = {
                        ConnectionName: connection.Name,
                        ConnectionRole: connection.Role,
                        ContactName: currentContact.Name + (currentContact.Surname ? ' ' + currentContact.Surname : ''),
                        Email: email.Address,
                        CC: email.CC,
                    };
                    emails.push(emailItem);
                }
            }
        }
        return emails;
    };

    const getMotherAgencyEmail = async (motherAgencyID) => {
        const motagconnections = await Axios.get(`/contacts/connections/${motherAgencyID}`);
        const motagemails = getEmailsFromConnections(motagconnections);
        setMotherAgencyEmail(motagemails);
    };

    useEffect(() => {
        if (currentContact && Connections) {
            //get all emails from connections
            const emails = getEmailsFromConnections(Connections);
            setContactEmails(emails);
            //get mother agency email
            if (currentContact.MotherAgencyID) {
                setMotherAgencyName(currentContact.MotherAgencyName);
                getMotherAgencyEmail(currentContact.MotherAgencyID);
            }
        }
    }, [contactID]);

    const isSelected = (emailAddress) => {
        if (!selectedItems || selectedItems.length === 0) {
            return false;
        }
        return selectedItems.find((selectedEmail) => selectedEmail.Email === emailAddress);
    };

    if (isLoadingContact || isLoadingConnections) {
        return <Skeleton active />;
    }

    return (
        <Wrapper>
            <div className="related-emails-box">
                <h2>
                    <NwIcon icon={byPrefixAndName.fasl['user']} style={{ marginRight: '0.5rem' }} />{' '}
                    {currentContact.Name} {currentContact.Surname}
                </h2>
                <div className="related-emails-box-content">
                    {contactEmails.map((email) => (
                        <EmailSearchItem
                            key={email.Email}
                            email={email}
                            onSelect={onAddEmail}
                            selected={isSelected(email.Email)}
                        />
                    ))}
                </div>
            </div>
            {motherAgencyName && (
                <div className="related-emails-box">
                    <h2>
                        <NwIcon icon={byPrefixAndName.fasl['globe']} style={{ marginRight: '0.5rem' }} />{' '}
                        {motherAgencyName} (Mother agency)
                    </h2>
                    <div className="related-emails-box-content">
                        {motherAgencyEmail.map((email) => (
                            <EmailSearchItem
                                key={email.Email}
                                email={email}
                                onSelect={onAddEmail}
                                selected={isSelected(email.Email)}
                            />
                        ))}
                    </div>
                </div>
            )}
        </Wrapper>
    );
};

export default EmailContactRelated;
